export const minWidthValue = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
};

export const hasMinWidthMediaQuery = {
    xs: `screen and (min-width: ${minWidthValue.xs}px)`,
    sm: `screen and (min-width: ${minWidthValue.sm}px)`,
    md: `screen and (min-width: ${minWidthValue.md}px)`,
    lg: `screen and (min-width: ${minWidthValue.lg}px)`,
};

export const canHoverMediaQuery = "(hover), (-ms-high-contrast: active), (-ms-high-contrast: none)";
export const canNotHoverMediaQuery = "(hover: none)";

export const printMediaQuery = "print";
